export const NoPetFoundSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="326"
      height="280"
      fill="none"
      viewBox="0 0 326 280"
    >
      <g clipPath="url(#clip0_33_15331)">
        <path
          fill="#F2F2F2"
          d="M263.227 280c34.669 0 62.773-5.809 62.773-12.975s-28.104-12.974-62.773-12.974c-34.668 0-62.772 5.809-62.772 12.974 0 7.166 28.104 12.975 62.772 12.975"
        ></path>
        <path
          fill="#E6E6E6"
          d="M19.197 163.24c.374.872.77 1.753 1.177 2.62l-.871.408a86 86 0 0 1-1.19-2.648zM174.55 93.49a87 87 0 0 1 1.569 3.547l-.889.37a87 87 0 0 0-2.408-5.282l.861-.428q.442.889.867 1.793m-3.657-6.957-.83.486a86 86 0 0 0-3.101-4.905l.796-.542a86 86 0 0 1 3.135 4.96m7.295 15.996a85 85 0 0 1 1.689 5.621l-.93.244a86 86 0 0 0-1.67-5.556zm-13.899-25.69-.756.594A85 85 0 0 0 159.789 73l.713-.646a85 85 0 0 1 3.787 4.485m16.887 37.035c.365 1.913.668 3.865.901 5.8l-.955.115a85 85 0 0 0-.891-5.735zm-24.761-45.733-.667.694a85 85 0 0 0-4.314-3.872l.618-.738a87 87 0 0 1 4.363 3.916m26.161 57.391a85 85 0 0 1 .093 5.876l-.962-.018a85 85 0 0 0-.092-5.81zm-35.147-64.915-.566.779a85 85 0 0 0-4.806-3.246l.511-.816a86 86 0 0 1 4.861 3.283m34.929 76.657a86 86 0 0 1-.713 5.831l-.95-.15c.299-1.902.536-3.842.705-5.765zm-44.865-82.882-.454.848a85 85 0 0 0-5.206-2.562l.395-.877c1.776.8 3.547 1.67 5.265 2.59m43.042 94.48a87 87 0 0 1-1.5 5.677l-.921-.278a85 85 0 0 0 1.483-5.613zm-53.738-99.298-.334.902a86 86 0 0 0-5.508-1.831l.273-.923a87 87 0 0 1 5.569 1.852m50.355 110.535a86 86 0 0 1-2.257 5.418l-.875-.4a86 86 0 0 0 2.232-5.357zm-61.61-113.855-.209.94a85 85 0 0 0-5.707-1.066l.144-.951c1.929.292 3.872.654 5.772 1.077m56.733 124.524a86 86 0 0 1-2.972 5.059l-.812-.515a86 86 0 0 0 2.939-5.003zm-68.339-126.28-.078.958a85 85 0 0 0-5.803-.275l.013-.962a85 85 0 0 1 5.868.278m62.058 136.182a86 86 0 0 1-3.634 4.603l-.734-.622c1.243-1.469 2.452-3 3.592-4.551zm-73.8-136.334.054.96a85 85 0 0 0-5.788.527l-.12-.955a85 85 0 0 1 5.853-.532m66.226 145.277a85 85 0 0 1-4.235 4.065l-.641-.717a85 85 0 0 0 4.187-4.019zM80.545 45.813l.185.944a85 85 0 0 0-5.651 1.316l-.25-.929a86 86 0 0 1 5.716-1.331m69.135 151.636a85 85 0 0 1-4.754 3.442l-.537-.798a84 84 0 0 0 4.7-3.404zM69.219 48.865l.313.91a86 86 0 0 0-5.418 2.077l-.375-.887a87 87 0 0 1 5.48-2.1M139.948 204a87 87 0 0 1-5.179 2.761l-.423-.864a85 85 0 0 0 5.12-2.731zM58.847 54.292a86 86 0 0 0-5.09 2.787l-.49-.828a87 87 0 0 1 5.146-2.82zm-9.978 5.915a85 85 0 0 0-4.66 3.457l-.6-.753a86 86 0 0 1 4.714-3.497zm-9.072 7.227a85 85 0 0 0-4.137 4.06l-.697-.663a85 85 0 0 1 4.184-4.106zm-7.984 8.398a85 85 0 0 0-3.542 4.593l-.782-.561a86 86 0 0 1 3.582-4.645zm-6.76 9.42a86 86 0 0 0-2.883 5.035l-.85-.45a86 86 0 0 1 2.914-5.092zm-5.415 10.257a85 85 0 0 0-2.172 5.383l-.904-.33a87 87 0 0 1 2.196-5.444zm-3.971 10.902a86 86 0 0 0-1.42 5.629l-.94-.203a87 87 0 0 1 1.435-5.693zm-2.454 11.343a86 86 0 0 0-.639 5.772l-.96-.072c.149-1.942.366-3.906.647-5.839zm-.88 11.576c-.014 1.93.04 3.884.159 5.807l-.96.06a86 86 0 0 1-.161-5.874zm.718 11.591c.251 1.91.573 3.836.956 5.724l-.943.191a85 85 0 0 1-.967-5.79zm2.304 11.369a85 85 0 0 0 1.734 5.539l-.909.318a86 86 0 0 1-1.752-5.601zM128.921 208.33l.363.891c-.899.366-1.81.72-2.706 1.05l-.332-.903a86 86 0 0 0 2.675-1.038"
        ></path>
        <path
          fill="#3F3D56"
          d="M174.151 168.051c-.096-.157-2.36-3.939-3.145-11.791-.72-7.204-.257-19.348 6.039-36.286 11.93-32.09-2.749-57.982-2.899-58.24l.724-.42c.039.066 3.826 6.667 6.064 17.179a74.95 74.95 0 0 1-3.104 41.772c-11.909 32.035-3.055 47.2-2.964 47.35z"
        ></path>
        <path
          fill="#2460B8"
          d="M169.487 59.85a5.44 5.44 0 1 0-.002-10.88 5.44 5.44 0 0 0 .002 10.88"
        ></path>
        <path
          fill="#3F3D56"
          d="M186.644 79.94a5.441 5.441 0 1 0 0-10.882 5.441 5.441 0 0 0 0 10.882"
        ></path>
        <path
          fill="#2460B8"
          d="M174.927 93.333a5.44 5.44 0 1 0-.002-10.881 5.44 5.44 0 0 0 .002 10.881M189.155 104.634a5.44 5.44 0 0 0 5.44-5.441 5.44 5.44 0 1 0-10.88 0 5.44 5.44 0 0 0 5.44 5.441"
        ></path>
        <path
          fill="#3F3D56"
          d="M170.742 122.212a5.44 5.44 0 1 0 0-10.881 5.44 5.44 0 0 0 0 10.881M177.438 168.251s-5.44-13.393 10.88-23.438zM170.747 168.008s-2.476-14.242-21.639-14.12zM134.832 68.16a.83.83 0 0 0-.592 1.536 24.6 24.6 0 0 1 7.35 6.272c9.382 11.91 6.106 30.14-7.317 40.717a33.07 33.07 0 0 1-21.033 7.267c9.014 2.54 19.653.542 28.226-6.213 13.424-10.577 16.7-28.807 7.317-40.718a25.24 25.24 0 0 0-13.951-8.862"
        ></path>
        <path
          fill="#2460B8"
          d="M141.59 76.148c9.382 11.911 6.106 30.141-7.317 40.717a33.54 33.54 0 0 1-17.088 7.092 33.13 33.13 0 0 0 20.515-7.272c13.423-10.577 16.699-28.806 7.317-40.717a24.86 24.86 0 0 0-10.127-7.612l-.062-.015a.83.83 0 0 0-.965.512.83.83 0 0 0 .379 1.025 24.7 24.7 0 0 1 7.348 6.27M99.979 57.758l5.538 9.593 5.538 9.594H88.902l5.539-9.593z"
        ></path>
        <path
          fill="#2460B8"
          d="m120.179 57.758 5.539 9.593 5.538 9.594h-22.153l5.538-9.593z"
        ></path>
        <path
          fill="#3F3D56"
          d="m99.338 62.762 3.417 5.92 3.417 5.918H92.504l3.417-5.919zM120.098 62.762l3.417 5.92 3.417 5.918h-13.668l3.417-5.919zM149.037 126.009a38.966 38.966 0 0 1-30.521 38.041 38.96 38.96 0 0 1-46.284-47.288 38.96 38.96 0 0 1 38.679-29.706 38.96 38.96 0 0 1 34.472 22.479 39 39 0 0 1 3.654 16.474"
        ></path>
        <path
          fill="#000"
          d="M135.106 96.15c-3.259 8.512-13.231 14.707-25.027 14.707-11.795 0-21.768-6.194-25.027-14.707a38.95 38.95 0 0 1 50.054 0"
          opacity="0.1"
        ></path>
        <path
          fill="#3F3D56"
          d="M110.079 107.791c14.444 0 26.152-9.288 26.152-20.744 0-11.457-11.708-20.744-26.152-20.744-14.443 0-26.152 9.287-26.152 20.744s11.708 20.744 26.152 20.744"
        ></path>
        <path
          fill="#fff"
          d="M97.815 89.03a4.87 4.87 0 1 0-.001-9.739 4.87 4.87 0 0 0 0 9.74M122.343 89.03a4.87 4.87 0 1 0 0-9.74 4.87 4.87 0 0 0 0 9.74"
        ></path>
        <path
          fill="#3F3D56"
          d="M97.814 87.227a3.066 3.066 0 1 0 0-6.132 3.066 3.066 0 0 0 0 6.132M122.343 87.227a3.067 3.067 0 1 0 0-6.133 3.067 3.067 0 0 0 0 6.133"
        ></path>
        <path
          fill="#2460B8"
          d="M104.61 91.915a.902.902 0 1 0 0-1.804.902.902 0 0 0 0 1.804"
        ></path>
        <path
          fill="#2460B8"
          d="M104.263 90.785c-1.769.803-2.94 2.438-4.799 3.141a8.8 8.8 0 0 1-5.894.11c-.332-.11-.474.412-.144.522 1.922.64 4 .635 5.918-.015a9 9 0 0 0 2.523-1.34c.887-.673 1.641-1.484 2.669-1.951.317-.144.042-.61-.273-.467"
        ></path>
        <path
          fill="#2460B8"
          d="M104.968 90.554c-.904.209-1.776.538-2.592.98a8.9 8.9 0 0 1-2.988.841 8.78 8.78 0 0 1-5.589-1.415c-.292-.19-.564.278-.273.468a9.28 9.28 0 0 0 5.583 1.508 8.9 8.9 0 0 0 2.794-.606c1.076-.429 2.052-1.055 3.209-1.254.342-.059.197-.58-.144-.522"
        ></path>
        <path
          fill="#2460B8"
          d="M104.485 90.204c-1.378 1.3-1.95 3.178-3.411 4.436a8.77 8.77 0 0 1-5.647 2.122.27.27 0 0 0 0 .541 9.3 9.3 0 0 0 5.555-1.895 9 9 0 0 0 1.882-1.942c.681-.963 1.132-2.057 2.003-2.88.254-.239-.129-.62-.382-.382M114.105 91.915a.902.902 0 1 0 0-1.804.902.902 0 0 0 0 1.804"
        ></path>
        <path
          fill="#2460B8"
          d="M114.179 91.252c1.016.462 1.768 1.26 2.641 1.93a9 9 0 0 0 2.55 1.36 9.28 9.28 0 0 0 5.919.015c.329-.109.188-.631-.144-.521a8.8 8.8 0 0 1-5.894-.11c-1.859-.704-3.03-2.338-4.799-3.141-.315-.143-.59.323-.273.467"
        ></path>
        <path
          fill="#2460B8"
          d="M113.603 91.076c1.112.192 2.051.778 3.079 1.203.931.382 1.92.604 2.925.657a9.27 9.27 0 0 0 5.582-1.508c.291-.19.02-.659-.273-.468a8.75 8.75 0 0 1-5.589 1.415 9 9 0 0 1-2.988-.84 10.4 10.4 0 0 0-2.592-.98c-.34-.06-.487.462-.144.521"
        ></path>
        <path
          fill="#2460B8"
          d="M113.848 90.587c.87.821 1.322 1.917 2.003 2.88a9 9 0 0 0 1.882 1.941 9.3 9.3 0 0 0 5.556 1.895.27.27 0 0 0 0-.54 8.74 8.74 0 0 1-5.648-2.123c-1.455-1.263-2.034-3.136-3.41-4.436-.254-.239-.637.143-.383.383"
        ></path>
        <path
          fill="#3F3D56"
          d="M97.815 167.677c3.984 0 7.214-1.857 7.214-4.148 0-2.292-3.23-4.149-7.215-4.149s-7.214 1.857-7.214 4.149 3.23 4.148 7.215 4.148M122.343 167.677c3.985 0 7.215-1.857 7.215-4.148 0-2.292-3.23-4.149-7.215-4.149s-7.214 1.857-7.214 4.149 3.23 4.148 7.214 4.148"
        ></path>
        <path
          fill="#2460B8"
          d="M109.358 94.262c3.287 0 5.952-1.535 5.952-3.427s-2.665-3.428-5.952-3.428-5.952 1.535-5.952 3.428c0 1.892 2.665 3.427 5.952 3.427"
        ></path>
        <path
          fill="#F2F2F2"
          d="M0 0v232.706h311.772V0zm40.175 2.93a5.022 5.022 0 1 1 0 10.043 5.022 5.022 0 0 1 0-10.043M10.044 12.975a5.022 5.022 0 1 1 0-10.044 5.022 5.022 0 0 1 0 10.044m10.043-5.023a5.023 5.023 0 1 1 10.046 0 5.023 5.023 0 0 1-10.046 0m172.835 159.462H25.109V42.691h167.813z"
        ></path>
        <path
          fill="#fff"
          d="M305.076 4.186h-10.044V5.44h10.044zM305.076 7.952h-10.044v1.256h10.044zM305.076 11.719h-10.044v1.255h10.044zM295.032 40.598h-75.746v3.767h75.746zM295.032 53.572h-75.746v3.767h75.746zM295.032 66.547h-75.746v3.767h75.746zM295.032 79.522h-75.746v3.766h75.746zM295.032 92.496h-75.746v3.767h75.746zM295.032 105.471h-75.746v3.767h75.746zM295.032 118.445h-75.746v3.767h75.746zM295.032 131.42h-75.746v3.767h75.746zM295.032 144.395h-75.746v3.766h75.746zM295.032 157.369h-75.746v3.767h75.746zM35.153 181.226a5.022 5.022 0 1 0-.002-10.045 5.022 5.022 0 0 0 .002 10.045M52.31 181.226a5.022 5.022 0 1 0 0-10.045 5.022 5.022 0 0 0 0 10.045M69.469 181.226a5.022 5.022 0 1 0-.002-10.045 5.022 5.022 0 0 0 .002 10.045"
        ></path>
        <path fill="#2460B8" d="M295.032 200.897h-75.746v21.345h75.746z"></path>
        <path
          fill="#2F2E41"
          d="m256.933 183.924.847 29.654 9.036 34.737s-1.976 5.93-.564 7.343c1.412 1.412 7.906 3.953 7.906 3.953l-5.365-73.993z"
        ></path>
        <path
          fill="#2F2E41"
          d="M276.551 255.513s3.223 7.09-1.289 7.735c-4.511.644-25.35 2.363-24.061-1.29s16.972-7.09 16.972-7.09z"
        ></path>
        <path
          fill="#2F2E41"
          d="M288.56 157.659s-3.389 18.357-5.648 21.464 1.13 25.7 1.13 25.7 5.082 32.478 2.823 37.561c-2.259 5.084-1.694 3.389-1.411 6.213s.847 5.084 0 7.625c-.848 2.542-.848 2.26-1.13 3.672s0 9.037 0 9.037-12.142 4.236-14.119-1.977c0 0 2.824-3.954 1.977-7.06a37.6 37.6 0 0 1-1.412-9.602v-5.931l-12.99-48.576-3.106-17.509s.847-17.793 3.953-19.487c3.106-1.695 29.933-1.13 29.933-1.13"
        ></path>
        <path
          fill="#2F2E41"
          d="M283.477 267.519s4.236 9.32-1.694 10.167-33.321 3.107-31.627-1.694 22.308-9.32 22.308-9.32z"
        ></path>
        <path
          fill="#FFB9B9"
          d="M278.109 76.335c6.238 0 11.295-5.058 11.295-11.297s-5.057-11.296-11.295-11.296-11.296 5.057-11.296 11.296c0 6.24 5.058 11.297 11.296 11.297"
        ></path>
        <path
          fill="#FFB9B9"
          d="m286.046 70.03-.211 14.427-13.848.047s3.515-11.294 1.941-13.655c-1.575-2.362 12.118-.819 12.118-.819"
        ></path>
        <path
          fill="#3F3D56"
          d="M265.404 92.42s9.884-12.708 17.508-7.342 10.448 18.074 10.448 18.074l-1.694 35.585s-4.236 5.083-1.694 8.472 3.953 2.542 1.976 5.084-4.235 4.519-3.388 5.366-.847 1.412-.847 1.412l-29.933.847s.847-1.13-1.694-4.519.564-7.907 0-9.602c-.565-1.694-1.13.283-1.412-3.671s10.73-49.705 10.73-49.705"
        ></path>
        <path
          fill="#FFB9B9"
          d="M268.228 165.284s-.565 7.061-4.8 8.19c-1.589.424-2.78-.384-3.649-1.559a6.94 6.94 0 0 1-.221-7.781l1.046-1.674z"
        ></path>
        <path
          fill="#3F3D56"
          d="M294.349 78.159s.282 5.648 0 6.496c-.283.847-.565 1.694 0 2.541.564.847.282 3.672-.283 3.954s1.13 2.824.565 4.519c-.565 1.694-1.13 2.26-1.412 2.824s-.737 1.577-.737 1.577-8.299-17.675-15.076-13.438c-6.778 4.236-12.143 5.648-12.143 5.648s3.671-19.77 29.086-14.121"
        ></path>
        <path
          fill="#3F3D56"
          d="M282.065 91.291s9.036.847 8.471 12.709.848 30.501.848 30.501-15.531 23.723-18.073 25.417-2.824 1.412-2.541 2.825c.282 1.412.564 2.541-.565 3.671a9.8 9.8 0 0 1-2.259 1.694s-9.036-3.106-8.189-5.93 4.8-7.343 4.8-7.343 6.777-11.014 7.06-12.709c.282-1.694.282-1.412 1.129-2.259.848-.847 3.107-4.236 3.107-5.931v-5.366l-2.368-28.675a8.313 8.313 0 0 1 2.205-6.438c1.343-1.407 3.375-2.526 6.375-2.166"
        ></path>
        <path
          fill="#2F2E41"
          d="M270.824 56.327a4.6 4.6 0 0 1-4.264-.977c-1.104-1.049-1.475-2.866-.69-4.171.678-1.127 1.997-1.678 3.253-2.07a28.8 28.8 0 0 1 8.552-1.304c1.382 0 2.826.118 4.009.833.586.354 1.081.84 1.66 1.205 1.065.67 2.342.894 3.511 1.36a9 9 0 0 1 5.132 5.435c.268.828.436 1.686.499 2.554a14 14 0 0 1-1.22 6.934c-1.576 3.436-4.575 6.325-4.999 10.081-1.614-1.355-2.087-3.628-3.337-5.325a6.9 6.9 0 0 0-3.77-2.559 2.2 2.2 0 0 1-1.141-.51 1.9 1.9 0 0 1-.357-1.029l-.775-5.58c-.158-1.136-.371-2.378-1.243-3.123a4.4 4.4 0 0 0-1.85-.803 30 30 0 0 0-4.83-.788"
        ></path>
        <path
          fill="#000"
          d="m290.01 138.535-15.852 20.574s14.597-12.203 15.852-20.574M274.795 115.756l.15 19.431-9.207 13.811 7.533-15.485z"
          opacity="0.1"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_33_15331">
          <path fill="#fff" d="M0 0h326v280H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const CompletedFlowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="370"
      height="250"
      fill="none"
      viewBox="0 0 370 250"
    >
      <g clipPath="url(#clip0_33_31046)">
        <path
          fill="#F2F2F2"
          d="M338.448 87.472a37 37 0 0 1-1.174.924h-98.1q-1.096-.45-2.183-.924a115.6 115.6 0 0 1-28.61-17.786c-5.72-4.839-10.983-9.835-14.798-14.516-5.322-6.534-10.224-13.654-12.504-21.766-2.275-8.113-1.595-17.412 3.487-24.14a21.6 21.6 0 0 1 5.711-5.221q.547-.348 1.114-.66c6.095-3.417 13.785-4.249 20.648-2.48 9.826 2.535 17.993 9.613 23.819 17.915 5.827 8.297 9.61 17.827 13.337 27.251 3.783-16.82 15.237-31.887 30.71-39.547 15.468-7.66 34.687-7.568 49.827.73a50.1 50.1 0 0 1 12.74 10.019q.547.59 1.072 1.2c7.385 8.538 12.005 19.472 12.384 30.747.486 14.526-6.256 29.116-17.48 38.254"
        ></path>
        <path
          fill="#fff"
          d="M243.096 88.395h-1.388a103.332 103.332 0 0 0-3.103-18.81 110.2 110.2 0 0 0-17.715-37.151 105.7 105.7 0 0 0-30.289-27.916.65.65 0 0 1-.324-.476.69.69 0 0 1 .282-.683.694.694 0 0 1 .832.023c6.704 4.08 12.928 8.9 18.553 14.369a111.2 111.2 0 0 1 23.912 34.228 107.7 107.7 0 0 1 9.24 36.416M343.544 18.472a.1.1 0 0 1-.032.009 137.431 137.431 0 0 0-27.237 7.923 143 143 0 0 0-22.428 11.543 145 145 0 0 0-20.092 15.274 142 142 0 0 0-17.106 18.525 137 137 0 0 0-10.455 15.726q-.263.458-.518.924h-1.586q.249-.466.513-.924a138.5 138.5 0 0 1 12.939-19.083 143.6 143.6 0 0 1 17.716-18.354 147 147 0 0 1 20.522-14.904 144.3 144.3 0 0 1 22.9-11.156 137.5 137.5 0 0 1 23.792-6.704l.675-.125c.864-.157 1.234 1.145.397 1.326"
        ></path>
        <path
          fill="#2F2E41"
          d="M91.413 91.14c2.467-4.65 2.874-10.706-.193-14.985-1.826-2.547-4.677-4.219-7.668-5.162s-6.148-1.22-9.276-1.45c-3.097-.226-6.25-.408-9.275.292s-5.956 2.408-7.43 5.137c-2.49 4.61-.221 10.523-2.05 15.432-1.678 4.506-6.454 7.14-11.15 8.203-4.694 1.063-9.595.95-14.292 2.002-4.698 1.053-9.482 3.662-11.19 8.157-1.235 3.25-.621 6.993 1.006 10.066s4.177 5.561 6.882 7.748c4.036 3.264 8.758 6.059 13.944 6.342 5.464.298 10.807-2.299 14.74-6.099 3.932-3.799 6.61-8.709 8.749-13.738 1.357-3.191 2.64-6.624 5.359-8.779 1.998-1.583 4.54-2.277 7.005-2.933l2.79-.742a19.2 19.2 0 0 0 6.956-3.44 19.1 19.1 0 0 0 5.093-6.05"
        ></path>
        <path
          fill="#FFB8B8"
          d="M69.401 244.099h-5.668l-2.698-21.834h8.368z"
        ></path>
        <path
          fill="#2F2E41"
          d="M59.682 242.481h10.934v6.874H52.798a6.86 6.86 0 0 1 2.016-4.86 6.884 6.884 0 0 1 4.868-2.014"
        ></path>
        <path
          fill="#FFB8B8"
          d="M116.568 244.099H110.9l-2.698-21.834h8.368z"
        ></path>
        <path
          fill="#2F2E41"
          d="M106.85 242.481h10.934v6.874H99.966a6.86 6.86 0 0 1 2.016-4.86 6.89 6.89 0 0 1 4.868-2.014M80.3 226.745q-.12 0-.238-.013l-23.064-2.467a2.17 2.17 0 0 1-1.9-1.743 2.2 2.2 0 0 1 .02-.913l20.423-77.556a2.18 2.18 0 0 1 1.64-1.613l18.944-5.273a2.19 2.19 0 0 1 2.103.685c12.181 13.718 21.36 44.128 28.314 82.457a2.18 2.18 0 0 1-.385 1.667 2.17 2.17 0 0 1-1.475.868l-18.899 2.409a2.163 2.163 0 0 1-2.391-1.674l-9.195-40.932a1.684 1.684 0 0 0-1.665-1.316 1.687 1.687 0 0 0-1.635 1.354l-8.477 42.318a2.156 2.156 0 0 1-2.12 1.742"
        ></path>
        <path
          fill="#FFB8B8"
          d="M76.79 101.79c6.273 0 11.358-5.077 11.358-11.34S83.063 79.11 76.79 79.11c-6.272 0-11.357 5.077-11.357 11.34s5.085 11.34 11.357 11.34"
        ></path>
        <path
          fill="#CCC"
          d="M76.473 144.271a2.161 2.161 0 0 1-2.09-1.61l-6.834-25.63a7.74 7.74 0 0 1 .574-5.501 7.75 7.75 0 0 1 4.102-3.717c5.5-2.144 10.74-2.939 15.574-2.365 4.297.512 9.598 25.912 9.247 26.454l1.696 5.079a2.16 2.16 0 0 1-.77 2.427 2.2 2.2 0 0 1-.822.373l-20.206 4.438a2.2 2.2 0 0 1-.471.052"
        ></path>
        <path
          fill="#FFB8B8"
          d="M82.597 170.482a3.514 3.514 0 0 0-3.407-4.179l-3.937-11.852-4.023 5.096 4.355 10.474a3.54 3.54 0 0 0 7.012.461M133.209 141.997a3.51 3.51 0 0 0-2.356-1.819 3.53 3.53 0 0 0-2.909.636l-10.431-6.89-.009 6.489 9.906 5.548a3.543 3.543 0 0 0 4.663.59 3.533 3.533 0 0 0 1.136-4.554"
        ></path>
        <path
          fill="#CCC"
          d="M74.344 165.006a2.17 2.17 0 0 1-2.06-1.486l-9.229-19.492a11.3 11.3 0 0 1-.57-3.541l2.774-25.336c0-1.419.542-2.784 1.516-3.817a5.58 5.58 0 0 1 7.63-.461 5.57 5.57 0 0 1 1.966 3.606l-4.245 28.918 6.774 17.749a2.16 2.16 0 0 1-1.146 2.413l-2.44 1.218a2.16 2.16 0 0 1-.97.229M123.632 144.556c-.34 0-.675-.08-.979-.233l-18.352-9.256a11.3 11.3 0 0 1-2.908-2.106l-17.914-17.943a5.565 5.565 0 0 1 3.454-9.477 5.59 5.59 0 0 1 3.942 1.168l19.404 21.518 15.382 9.752a2.16 2.16 0 0 1 .894 2.516l-.867 2.584a2.17 2.17 0 0 1-2.056 1.477"
        ></path>
        <path
          fill="#2F2E41"
          d="M63.872 84.587a13.23 13.23 0 0 0 7.813 4.908c3.152.65 6.433.181 9.276-1.327 2.288-1.234 4.118-3.086 5.911-4.91.748-.76 1.545-1.638 1.507-2.676-.058-1.609-1.995-2.488-3.657-2.839a26.13 26.13 0 0 0-16.2 1.82c-2.256 1.046-4.608 2.94-4.269 5.293"
        ></path>
        <path
          fill="#3F3D56"
          d="M362.139 87.472H139.248a7.88 7.88 0 0 0-5.555 2.302 7.85 7.85 0 0 0-2.306 5.547v85.882a7.85 7.85 0 0 0 2.306 5.547 7.88 7.88 0 0 0 5.555 2.302h222.891a7.88 7.88 0 0 0 5.556-2.302 7.86 7.86 0 0 0 2.305-5.547V95.322a7.86 7.86 0 0 0-2.305-5.548 7.88 7.88 0 0 0-5.556-2.302m6.936 93.731a6.93 6.93 0 0 1-2.034 4.895 6.95 6.95 0 0 1-4.902 2.031H139.248a6.95 6.95 0 0 1-4.902-2.031 6.93 6.93 0 0 1-2.034-4.895V95.322a6.93 6.93 0 0 1 2.034-4.895 6.95 6.95 0 0 1 4.902-2.031h222.891a6.95 6.95 0 0 1 4.902 2.03 6.93 6.93 0 0 1 2.034 4.895z"
        ></path>
        <path
          fill="#3F3D56"
          d="M179.716 165.042c-5.304 0-10.49-1.57-14.9-4.513a26.8 26.8 0 0 1-9.879-12.019 26.74 26.74 0 0 1-1.526-15.472 26.77 26.77 0 0 1 7.34-13.712 26.859 26.859 0 0 1 29.229-5.806 26.8 26.8 0 0 1 12.037 9.864 26.75 26.75 0 0 1 4.52 14.878 26.8 26.8 0 0 1-7.864 18.928 26.87 26.87 0 0 1-18.957 7.852m0-52.637a25.93 25.93 0 0 0-14.387 4.358 25.86 25.86 0 0 0-9.537 11.604 25.82 25.82 0 0 0 5.613 28.179 25.929 25.929 0 0 0 28.221 5.605 25.9 25.9 0 0 0 11.622-9.524 25.82 25.82 0 0 0 4.364-14.365 25.86 25.86 0 0 0-7.593-18.275 25.95 25.95 0 0 0-18.303-7.582"
        ></path>
        <path
          fill="#2460B8"
          d="M342.247 121.178H235.426a5.78 5.78 0 0 0-5.771 5.546q-.012.112-.009.226a5.78 5.78 0 0 0 1.695 4.079 5.8 5.8 0 0 0 4.085 1.692h106.821a5.79 5.79 0 0 0 4.088-1.69 5.766 5.766 0 0 0 0-8.162 5.78 5.78 0 0 0-4.088-1.691M342.247 143.803H235.426a5.78 5.78 0 0 0-5.771 5.545 2 2 0 0 0-.009.226 5.78 5.78 0 0 0 1.695 4.079 5.8 5.8 0 0 0 4.085 1.693h106.821a5.78 5.78 0 0 0 4.088-1.691 5.766 5.766 0 0 0 0-8.162 5.79 5.79 0 0 0-4.088-1.69M176.724 149.963a3.46 3.46 0 0 1-2.076-.688l-.037-.028-7.817-5.976a3.47 3.47 0 0 1-1.243-3.648 3.465 3.465 0 0 1 2.9-2.542 3.48 3.48 0 0 1 2.568.685l5.063 3.876 11.965-15.58a3.47 3.47 0 0 1 3.654-1.24c.44.118.853.321 1.215.598l-.074.101.076-.1a3.47 3.47 0 0 1 .643 4.862l-14.074 18.327a3.47 3.47 0 0 1-2.763 1.353"
        ></path>
        <path
          fill="#3F3D56"
          d="M176.648 250H.462a.465.465 0 0 1-.462-.462.46.46 0 0 1 .462-.461h176.186a.46.46 0 1 1 0 .923"
        ></path>
        <path
          fill="#fff"
          d="M315.959 66.671a91.8 91.8 0 0 0-29.062.654 93.7 93.7 0 0 0-27.363 9.553 90.3 90.3 0 0 0-13.655 9.008c-.697.556.29 1.53.981.98a89.7 89.7 0 0 1 24.873-13.961 92.4 92.4 0 0 1 27.775-5.627 88.5 88.5 0 0 1 16.082.729.72.72 0 0 0 .853-.484.693.693 0 0 0-.484-.852"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_33_31046">
          <path fill="#fff" d="M0 0h370v250H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const EyeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="16"
      fill="none"
      viewBox="0 0 22 16"
    >
      <path
        stroke="#70767B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1.42 8.713c-.136-.215-.204-.323-.242-.49a1.2 1.2 0 0 1 0-.446c.038-.167.106-.275.242-.49C2.546 5.505 5.895 1 11 1s8.455 4.505 9.58 6.287c.137.215.205.323.243.49.029.125.029.321 0 .446-.038.167-.106.275-.242.49C19.455 10.495 16.105 15 11 15c-5.106 0-8.455-4.505-9.58-6.287"
      ></path>
      <path
        stroke="#70767B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M11 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
      ></path>
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#B82424"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M16 6v-.8c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 2 13.92 2 12.8 2h-1.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C8 3.52 8 4.08 8 5.2V6m2 5.5v5m4-5v5M3 6h18m-2 0v11.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C16.72 22 15.88 22 14.2 22H9.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C5 19.72 5 18.88 5 17.2V6"
      ></path>
    </svg>
  );
};


export const AddIcon = () => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 5v14m-7-7h14"
    ></path>
  </svg>
  )
}